import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "isWireFrame", "singleLine"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import WireFrameCell from '../../../../elements/wireframe-cell';
import { AddonContext, CardContext, CellContext, forceMobile } from '../generics';
import CellBase from './cell-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var capitalise = function capitalise(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var grid = function grid(rowOrCol, start, span) {
  var _ref;

  var singleLine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var rowOrColCap = capitalise(rowOrCol);
  return _ref = {}, _defineProperty(_ref, "grid".concat(rowOrColCap), singleLine ? forceMobile()(["1 / span ".concat(span), "".concat(start, " / span ").concat(span)]) : "".concat(start, " / span ").concat(span)), _defineProperty(_ref, "msGrid".concat(rowOrColCap), "".concat(start)), _defineProperty(_ref, "msGrid".concat(rowOrColCap, "Span"), "".concat(span)), _ref;
};

var RowContent = function RowContent(_ref2) {
  var accent = _ref2.accent,
      children = _ref2.children,
      inAddon = _ref2.inAddon,
      label = _ref2.label,
      mobileOrder = _ref2.mobileOrder,
      isCard = _ref2.isCard,
      _ref2$isWireFrame = _ref2.isWireFrame,
      isWireFrame = _ref2$isWireFrame === void 0 ? false : _ref2$isWireFrame;
  var wireFrameStyles = {
    label: {
      width: '45%',
      height: '10px'
    },
    description: {
      width: '95%',
      height: '17px'
    }
  };
  return _jsxs(CellBase, {
    mobileOrder: mobileOrder || (accent ? 1 : 2),
    sx: {
      height: 'auto',
      display: 'grid',
      alignItems: 'center',
      gridGap: 'sm',
      gridTemplateColumns: 'auto auto',
      msGridColumns: 'auto auto',
      gridTemplateRows: '100%',
      msGridRows: '100%',
      variant: "compounds.product-table.cellContent.variants.inSplit.".concat(accent ? 'accent' : 'main')
    } // @ts-ignore
    ,
    css: {
      display: '-ms-grid'
    },
    children: [_jsxs("div", {
      sx: _objectSpread(_objectSpread(_objectSpread({
        display: inAddon ? forceMobile(isCard)([undefined, 'none']) : undefined
      }, grid('column', 1, 1)), grid('row', 1, 1)), {}, {
        fontSize: 'xs',
        marginTop: '',
        variant: 'compounds.product-table.cellContent.variants.inSplit.label'
      }),
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.label
      }), !isWireFrame && label]
    }), _jsxs("div", {
      sx: _objectSpread(_objectSpread(_objectSpread({}, grid('column', 2, 1)), grid('row', 1, 1)), {}, {
        fontSize: 'sm',
        textAlign: 'right',
        small: {
          fontSize: 'sm'
        },
        variant: 'compounds.product-table.cellContent.variants.inSplit.content'
      }),
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.description
      }), !isWireFrame && children]
    })]
  });
};

var BlockContent = function BlockContent(_ref3) {
  var label = _ref3.label,
      accent = _ref3.accent,
      mobileOrder = _ref3.mobileOrder,
      children = _ref3.children,
      headerImage = _ref3.headerImage,
      isCard = _ref3.isCard,
      _ref3$isWireFrame = _ref3.isWireFrame,
      isWireFrame = _ref3$isWireFrame === void 0 ? false : _ref3$isWireFrame,
      _ref3$singleLine = _ref3.singleLine,
      singleLine = _ref3$singleLine === void 0 ? false : _ref3$singleLine;
  var wireFrameStyles = {
    label: {
      width: '45%',
      height: '10px'
    },
    description: {
      width: '65%',
      height: '17px'
    }
  };
  return _jsxs(CellBase, {
    mobileOrder: mobileOrder || (accent ? 1 : 2),
    sx: {
      height: accent ? '100%' : 'auto',
      display: 'grid',
      alignItems: 'start',
      gridTemplateColumns: '100%',
      msGridColumns: '100%',
      gridTemplateRows: '1fr',
      msGridRows: '1fr',
      padding: accent ? 'sm' : '',
      variant: headerImage ? "compounds.product-table.variants.redesign.cellContent.".concat(accent ? 'accent' : 'main') : "compounds.product-table.cellContent.".concat(accent ? 'accent' : 'main')
    } // @ts-ignore
    ,
    css: {
      display: '-ms-grid'
    },
    children: [_jsxs("div", {
      sx: _objectSpread(_objectSpread({}, grid('column', 1, 1)), {}, {
        gridRow: headerImage ? forceMobile(isCard)(['1 / span 1', '1 / span 1']) : forceMobile(isCard)(['1 / span 2', '2 / span 1']),
        msGridRow: forceMobile(isCard)(['1', '2']),
        msGridRowSpan: forceMobile(isCard)(['2', '1']),
        alignSelf: forceMobile(isCard)(['baseline', 'auto']),
        fontSize: 'xs',
        marginTop: singleLine ? 'auto' : headerImage ? 0 : forceMobile(isCard)(['xl', 'sm']),
        marginBottom: 'auto',
        variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.label")
      }),
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.label
      }), !isWireFrame && label]
    }), _jsxs("div", {
      sx: _objectSpread(_objectSpread(_objectSpread({}, grid('column', 1, 1)), grid('row', headerImage ? 2 : 1, 1, singleLine)), {}, {
        fontSize: isCard ? 'sm' : 'xxl',
        textAlign: isCard ? 'center' : 'left',
        small: {
          fontSize: 'sm'
        },
        lineHeight: 1,
        variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.content")
      }),
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.description
      }), !isWireFrame && children]
    })]
  });
};

var ProductTableCellContent = function ProductTableCellContent(_ref4) {
  var children = _ref4.children,
      isWireFrame = _ref4.isWireFrame,
      singleLine = _ref4.singleLine,
      props = _objectWithoutProperties(_ref4, _excluded);

  var _React$useContext = React.useContext(CellContext),
      inSplit = _React$useContext.inSplit;

  var _React$useContext2 = React.useContext(AddonContext),
      inAddon = _React$useContext2.inAddon;

  var _React$useContext3 = React.useContext(CardContext),
      isCard = _React$useContext3.isCard;

  if (inSplit || inAddon) {
    return _jsx(RowContent, _objectSpread(_objectSpread({
      inAddon: inAddon,
      isCard: isCard,
      isWireFrame: isWireFrame
    }, props), {}, {
      children: children
    }));
  }

  return _jsx(BlockContent, _objectSpread(_objectSpread({
    isCard: isCard,
    isWireFrame: isWireFrame,
    singleLine: singleLine
  }, props), {}, {
    children: children
  }));
};

export default ProductTableCellContent;
//# sourceMappingURL=cell-content.js.map